import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { useLanguage } from '../context/LanguageContext';
import ShareButtons from '../components/ShareButtons';
import { 
  Heart, 
  Calendar, 
  Sparkles, 
  ExternalLink,
  MessageCircle,
  Quote,
  ArrowRight
} from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

// Affiliate LifeWave Shop Link
const LIFEWAVE_SHOP_URL = 'https://lifewave.com/ioanaalexandra/store/products';
const WHATSAPP_NUMBER = '40766475946';

const storyTranslations = {
  en: {
    pageTitle: "My Story",
    subtitle: "A Journey of Hope and Healing",
    intro: "My story with LifeWave began one year ago, when through my mother, I discovered this technology that changed my life.",
    chapter1Title: "When It All Started",
    chapter1: "My health problems appeared immediately after I gave birth to my only child, 17 years ago, at the age of 25. After giving birth, my body simply was never the same. Hormonally, I never recovered. Around the age of 27, I was diagnosed with early premenopause.",
    chapter2Title: "The Desperate Search",
    chapter2: "I desperately tried to go to all kinds of doctors, checkups, I did all kinds of investigations, I spent a lot of money, time and false hopes - and I found no answer! After taking all kinds of treatments, I found no solution. I was told that my problem was most likely autoimmune and that I could only find my own balance and get used to taking a handful of medications.",
    chapter3Title: "The Suffering",
    chapter3: "And that wouldn't have been the problem - I would have taken them if they had made me feel better. But I had no results taking pills. Then, when at 32 years old menopause fully set in, joint problems appeared. Absolutely all my joints hurt more and more. I was like a rusty tin man in the morning when I woke up. Headaches and all kinds of problems. So many that wouldn't let me live, live well. I was tormented, a tormented person.",
    chapter4Title: "The Discovery",
    chapter4: "My mother guided me to use them because she had heard about them from a friend. I decided to try this too, although I had tried alternative therapies before without benefit.",
    chapter5Title: "The Transformation",
    chapter5: "And my surprise was very great to realize that from the first application, the pain diminished considerably. I can say that for 8 months now, I haven't put a single pill in my mouth. I had gotten to the point of injecting Tramadol, a very strong substance for pain, because nothing would make my headache go away. And I destroyed my liver and stomach with these pills.",
    encouragement: "I encourage everyone to give themselves a chance - a chance to live well, to live without pain, and in optimal balance.",
    yearsOfPain: "Years of Pain",
    monthsPainFree: "Months Pain-Free",
    pillsNow: "Pills Now",
    contactMe: "Contact Me",
    contactText: "Do you have a similar story? I'd love to hear from you and help you discover LifeWave.",
    shopNow: "Discover LifeWave Products",
    whatsapp: "Chat on WhatsApp"
  },
  ro: {
    pageTitle: "Povestea Mea",
    subtitle: "O Călătorie de Speranță și Vindecare",
    intro: "Povestea mea cu LifeWave a început acum un an de zile, când, prin intermediul mamei mele, am descoperit această tehnologie ce mi-a schimbat viața.",
    chapter1Title: "Când a Început Totul",
    chapter1: "Problemele mele de sănătate au apărut imediat după ce l-am născut pe unicul meu copil, în urmă cu 17 ani, la vârsta de 25 de ani. După naștere, corpul meu pur și simplu nu a mai fost la fel. Din punct de vedere hormonal, nu mi-am mai revenit. În jurul vârstei de 27 de ani am fost diagnosticată cu premenopauză precoce.",
    chapter2Title: "Căutarea Disperată",
    chapter2: "Am încercat disperată să merg la tot felul de medici, la controale, am făcut tot felul de investigații, am cheltuit foarte mulți bani, timp și speranțe deșarte și nu am găsit un răspuns! După ce am luat tot felul de tratamente, nu am găsit nicio soluție. Mi s-a spus că problema pe care o am eu cel mai probabil este una autoimună și că nu am decât să îmi găsesc eu echilibru și să mă obișnuiesc să iau un pumn de medicamente.",
    chapter3Title: "Suferința",
    chapter3: "Și nu asta ar fi fost problema, că le-aș fi luat dacă m-ar fi făcut să mă simt mai bine. Dar nu am avut niciun rezultat luând pastile. Au apărut după aceea, în momentul în care la 32 de ani s-a instalat complet menopauza, probleme articulare. Mă dureau absolut toate articulațiile din ce în ce mai rău. Eram așa, ca un om de tablă, ruginit dimineața când mă trezeam. Dureri de cap și tot felul de probleme. Foarte multe care nu mă lăsau să trăiesc, să trăiesc bine. Eram chinuită, un om chinuit.",
    chapter4Title: "Descoperirea",
    chapter4: "Mama mea m-a îndrumat să îi folosesc pentru că aflase de ei de la o prietenă. Am hotărât să încerc și asta, deși mai încercasem terapii alternative fără folos.",
    chapter5Title: "Transformarea",
    chapter5: "Și foarte mare mi-a fost surprinderea să realizez că de la prima aplicare s-au diminuat considerabil durerile. Pot spune că am opt luni de zile de când eu nu am mai pus gura pe nicio pastilă. Eu ajunsesem să îmi injectez Tramadol, o substanță foarte puternică pentru dureri, pentru că nu îmi trecea durerea de cap cu absolut nimic. Și mi-am făcut praf ficatul și stomacul cu aceste pastile.",
    encouragement: "Încurajez pe toată lumea să își acorde o șansă - o șansă de a trăi bine, de a trăi fără dureri și în echilibru optim.",
    yearsOfPain: "Ani de Durere",
    monthsPainFree: "Luni Fără Dureri",
    pillsNow: "Pastile Acum",
    contactMe: "Contactează-mă",
    contactText: "Ai o poveste similară? Mi-ar plăcea să te ascult și să te ajut să descoperi LifeWave.",
    shopNow: "Descoperă Produsele LifeWave",
    whatsapp: "Scrie-mi pe WhatsApp"
  },
  es: {
    pageTitle: "Mi Historia",
    subtitle: "Un Viaje de Esperanza y Sanación",
    intro: "Mi historia con LifeWave comenzó hace un año, cuando a través de mi madre, descubrí esta tecnología que cambió mi vida.",
    chapter1Title: "Cuando Todo Comenzó",
    chapter1: "Mis problemas de salud aparecieron inmediatamente después de dar a luz a mi único hijo, hace 17 años, a los 25 años. Después del parto, mi cuerpo simplemente ya no fue el mismo. Hormonalmente, nunca me recuperé. Alrededor de los 27 años, fui diagnosticada con premenopausia temprana.",
    chapter2Title: "La Búsqueda Desesperada",
    chapter2: "Intenté desesperadamente ir a todo tipo de médicos, chequeos, hice todo tipo de investigaciones, gasté mucho dinero, tiempo y falsas esperanzas - ¡y no encontré respuesta! Después de tomar todo tipo de tratamientos, no encontré solución. Me dijeron que mi problema probablemente era autoinmune y que solo podía encontrar mi propio equilibrio y acostumbrarme a tomar un puñado de medicamentos.",
    chapter3Title: "El Sufrimiento",
    chapter3: "Y ese no habría sido el problema - los habría tomado si me hubieran hecho sentir mejor. Pero no tuve resultados tomando pastillas. Luego, cuando a los 32 años la menopausia se instaló completamente, aparecieron problemas articulares. Absolutamente todas mis articulaciones dolían cada vez más. Era como un hombre de hojalata oxidado por la mañana al despertar. Dolores de cabeza y todo tipo de problemas. Tantos que no me dejaban vivir, vivir bien. Estaba atormentada.",
    chapter4Title: "El Descubrimiento",
    chapter4: "Mi madre me guió para usarlos porque había oído hablar de ellos por una amiga. Decidí probar esto también, aunque había probado terapias alternativas antes sin beneficio.",
    chapter5Title: "La Transformación",
    chapter5: "Y mi sorpresa fue muy grande al darme cuenta de que desde la primera aplicación, el dolor disminuyó considerablemente. Puedo decir que durante 8 meses no me he tomado ni una sola pastilla. Había llegado al punto de inyectarme Tramadol, una sustancia muy fuerte para el dolor, porque nada me quitaba el dolor de cabeza. Y destruí mi hígado y estómago con estas pastillas.",
    encouragement: "Animo a todos a darse una oportunidad - una oportunidad de vivir bien, de vivir sin dolor y en equilibrio óptimo.",
    yearsOfPain: "Años de Dolor",
    monthsPainFree: "Meses Sin Dolor",
    pillsNow: "Pastillas Ahora",
    contactMe: "Contáctame",
    contactText: "¿Tienes una historia similar? Me encantaría escucharte y ayudarte a descubrir LifeWave.",
    shopNow: "Descubre los Productos LifeWave",
    whatsapp: "Chatea en WhatsApp"
  },
  it: {
    pageTitle: "La Mia Storia",
    subtitle: "Un Viaggio di Speranza e Guarigione",
    intro: "La mia storia con LifeWave è iniziata un anno fa, quando attraverso mia madre ho scoperto questa tecnologia che ha cambiato la mia vita.",
    chapter1Title: "Quando Tutto è Iniziato",
    chapter1: "I miei problemi di salute sono comparsi subito dopo aver dato alla luce il mio unico figlio, 17 anni fa, all'età di 25 anni. Dopo il parto, il mio corpo semplicemente non è stato più lo stesso. Ormonalmente, non mi sono mai ripresa. Intorno ai 27 anni mi è stata diagnosticata la premenopausa precoce.",
    chapter2Title: "La Ricerca Disperata",
    chapter2: "Ho cercato disperatamente di andare da tutti i tipi di medici, controlli, ho fatto tutti i tipi di esami, ho speso molti soldi, tempo e false speranze - e non ho trovato risposta! Dopo aver preso tutti i tipi di trattamenti, non ho trovato soluzione. Mi è stato detto che il mio problema era molto probabilmente autoimmune e che potevo solo trovare il mio equilibrio e abituarmi a prendere una manciata di farmaci.",
    chapter3Title: "La Sofferenza",
    chapter3: "E quello non sarebbe stato il problema - li avrei presi se mi avessero fatto sentire meglio. Ma non ho avuto risultati prendendo pillole. Poi, quando a 32 anni la menopausa si è completamente installata, sono comparsi problemi articolari. Assolutamente tutte le mie articolazioni facevano sempre più male. Ero come un uomo di latta arrugginito la mattina quando mi svegliavo. Mal di testa e ogni tipo di problema. Così tanti che non mi lasciavano vivere, vivere bene. Ero tormentata.",
    chapter4Title: "La Scoperta",
    chapter4: "Mia madre mi ha guidato ad usarli perché ne aveva sentito parlare da un'amica. Ho deciso di provare anche questo, anche se avevo provato terapie alternative prima senza beneficio.",
    chapter5Title: "La Trasformazione",
    chapter5: "E la mia sorpresa è stata molto grande nel rendermi conto che dalla prima applicazione, il dolore è diminuito considerevolmente. Posso dire che per 8 mesi non ho messo in bocca una sola pillola. Ero arrivata al punto di iniettarmi Tramadolo, una sostanza molto forte per il dolore, perché niente mi faceva passare il mal di testa. E ho distrutto il mio fegato e stomaco con queste pillole.",
    encouragement: "Incoraggio tutti a darsi una possibilità - una possibilità di vivere bene, di vivere senza dolore e in equilibrio ottimale.",
    yearsOfPain: "Anni di Dolore",
    monthsPainFree: "Mesi Senza Dolore",
    pillsNow: "Pillole Ora",
    contactMe: "Contattami",
    contactText: "Hai una storia simile? Mi piacerebbe ascoltarti e aiutarti a scoprire LifeWave.",
    shopNow: "Scopri i Prodotti LifeWave",
    whatsapp: "Chatta su WhatsApp"
  },
  de: {
    pageTitle: "Meine Geschichte",
    subtitle: "Eine Reise der Hoffnung und Heilung",
    intro: "Meine Geschichte mit LifeWave begann vor einem Jahr, als ich durch meine Mutter diese Technologie entdeckte, die mein Leben veränderte.",
    chapter1Title: "Als Alles Begann",
    chapter1: "Meine Gesundheitsprobleme traten sofort nach der Geburt meines einzigen Kindes auf, vor 17 Jahren, im Alter von 25 Jahren. Nach der Geburt war mein Körper einfach nicht mehr derselbe. Hormonell habe ich mich nie erholt. Mit etwa 27 Jahren wurde bei mir eine frühe Prämenopause diagnostiziert.",
    chapter2Title: "Die Verzweifelte Suche",
    chapter2: "Ich versuchte verzweifelt, zu allen möglichen Ärzten zu gehen, Untersuchungen durchzuführen, ich gab viel Geld, Zeit und falsche Hoffnungen aus - und fand keine Antwort! Nach der Einnahme aller möglichen Behandlungen fand ich keine Lösung. Man sagte mir, dass mein Problem höchstwahrscheinlich autoimmun sei und ich nur mein eigenes Gleichgewicht finden und mich daran gewöhnen müsse, eine Handvoll Medikamente zu nehmen.",
    chapter3Title: "Das Leiden",
    chapter3: "Und das wäre nicht das Problem gewesen - ich hätte sie genommen, wenn sie mir geholfen hätten. Aber ich hatte keine Ergebnisse mit Pillen. Dann, als mit 32 Jahren die Menopause vollständig einsetzte, traten Gelenkprobleme auf. Absolut alle meine Gelenke schmerzten immer mehr. Ich war wie ein rostiger Blechmann am Morgen beim Aufwachen. Kopfschmerzen und alle möglichen Probleme. So viele, die mich nicht leben ließen, nicht gut leben. Ich war gequält.",
    chapter4Title: "Die Entdeckung",
    chapter4: "Meine Mutter führte mich dazu, sie zu benutzen, weil sie von einer Freundin davon gehört hatte. Ich beschloss, auch dies zu versuchen, obwohl ich zuvor alternative Therapien ohne Nutzen ausprobiert hatte.",
    chapter5Title: "Die Transformation",
    chapter5: "Und meine Überraschung war sehr groß, als ich feststellte, dass sich die Schmerzen von der ersten Anwendung an erheblich verringerten. Ich kann sagen, dass ich seit 8 Monaten keine einzige Pille mehr genommen habe. Ich war an dem Punkt angelangt, mir Tramadol zu spritzen, eine sehr starke Substanz gegen Schmerzen, weil nichts meine Kopfschmerzen vertrieb. Und ich habe meine Leber und meinen Magen mit diesen Pillen zerstört.",
    encouragement: "Ich ermutige jeden, sich eine Chance zu geben - eine Chance, gut zu leben, ohne Schmerzen zu leben und in optimalem Gleichgewicht.",
    yearsOfPain: "Jahre des Schmerzes",
    monthsPainFree: "Monate Schmerzfrei",
    pillsNow: "Pillen Jetzt",
    contactMe: "Kontaktiere Mich",
    contactText: "Hast du eine ähnliche Geschichte? Ich würde gerne von dir hören und dir helfen, LifeWave zu entdecken.",
    shopNow: "Entdecke LifeWave Produkte",
    whatsapp: "Chat auf WhatsApp"
  }
};

const MyStoryPage = () => {
  const { language } = useLanguage();
  const [customStory, setCustomStory] = useState(null);
  const [loading, setLoading] = useState(true);
  
  // Fetch custom story content from admin
  useEffect(() => {
    const fetchStory = async () => {
      try {
        const response = await axios.get(`${API_URL}/api/mystory`);
        if (response.data && Object.keys(response.data).length > 0) {
          setCustomStory(response.data);
        }
      } catch (error) {
        console.log('Using default story content');
      } finally {
        setLoading(false);
      }
    };
    fetchStory();
  }, []);
  
  // Get translation - first check custom content, then fallback to defaults
  const defaultT = storyTranslations[language] || storyTranslations['en'];
  const customT = customStory?.[language];
  
  // Helper to check if value exists and is not empty
  const hasValue = (val) => val && val.trim && val.trim().length > 0;
  
  // Merge custom content with defaults (custom takes priority if it exists and is not empty)
  const t = {
    ...defaultT,
    pageTitle: hasValue(customT?.title) ? customT.title : defaultT.pageTitle,
    intro: hasValue(customT?.intro) ? customT.intro : defaultT.intro,
    // If custom content exists, use it for chapters
    chapter1: hasValue(customT?.content) ? (customT.content.split('\n\n')[0] || defaultT.chapter1) : defaultT.chapter1,
    chapter2: hasValue(customT?.content) ? (customT.content.split('\n\n')[1] || defaultT.chapter2) : defaultT.chapter2,
    chapter3: hasValue(customT?.content) ? (customT.content.split('\n\n')[2] || defaultT.chapter3) : defaultT.chapter3,
    chapter4: hasValue(customT?.content) ? (customT.content.split('\n\n')[3] || defaultT.chapter4) : defaultT.chapter4,
    chapter5: hasValue(customT?.content) ? (customT.content.split('\n\n')[4] || defaultT.chapter5) : defaultT.chapter5,
    encouragement: hasValue(customT?.quote) ? customT.quote : defaultT.encouragement,
  };

  // Debug log to help troubleshoot
  console.log('MyStoryPage - language:', language, 'customT:', customT, 'using custom title:', hasValue(customT?.title));

  const handleWhatsApp = () => {
    const message = encodeURIComponent('Hello! I read your story and I would like to know more about LifeWave.');
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  return (
    <div className="min-h-screen bg-white" data-testid="my-story-page">
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-blue-50 via-white to-sky-50 py-20 overflow-hidden">
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute -top-40 -right-40 w-80 h-80 bg-sky-200/30 rounded-full blur-3xl"></div>
          <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-rose-200/20 rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative text-center">
          <div className="inline-flex items-center gap-2 bg-rose-100 text-rose-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            <Heart className="w-4 h-4 fill-current" />
            Ioana Alexandra
          </div>
          
          <h1 className="text-4xl sm:text-5xl font-bold text-slate-900 mb-4">
            {t.pageTitle}
          </h1>
          
          <p className="text-xl text-slate-600 max-w-2xl mx-auto">
            {t.subtitle}
          </p>
        </div>
      </section>

      {/* Stats Section */}
      <section className="py-12 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4">
          <div className="grid grid-cols-3 gap-4">
            <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
              <div className="text-4xl font-bold text-rose-500 mb-1">7+</div>
              <div className="text-sm text-slate-600">{t.yearsOfPain}</div>
            </div>
            <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
              <div className="text-4xl font-bold text-green-500 mb-1">8</div>
              <div className="text-sm text-slate-600">{t.monthsPainFree}</div>
            </div>
            <div className="bg-white rounded-2xl p-6 text-center shadow-sm">
              <div className="text-4xl font-bold text-sky-500 mb-1">0</div>
              <div className="text-sm text-slate-600">{t.pillsNow}</div>
            </div>
          </div>
        </div>
      </section>

      {/* Story Content */}
      <section className="py-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Intro Quote */}
          <div className="bg-sky-50 rounded-2xl p-8 mb-12 relative">
            <Quote className="absolute top-4 left-4 w-8 h-8 text-sky-300" />
            <p className="text-lg text-slate-700 italic pl-8">
              {t.intro}
            </p>
          </div>

          {/* Chapter 1 */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-rose-100 flex items-center justify-center">
                <Calendar className="w-5 h-5 text-rose-600" />
              </div>
              <h2 className="text-2xl font-bold text-slate-900">{t.chapter1Title}</h2>
            </div>
            <p className="text-slate-600 leading-relaxed pl-13">
              {t.chapter1}
            </p>
          </div>

          {/* Chapter 2 */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center">
                <span className="text-amber-600 text-xl">?</span>
              </div>
              <h2 className="text-2xl font-bold text-slate-900">{t.chapter2Title}</h2>
            </div>
            <p className="text-slate-600 leading-relaxed">
              {t.chapter2}
            </p>
          </div>

          {/* Chapter 3 */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-slate-200 flex items-center justify-center">
                <span className="text-slate-600 text-xl">💔</span>
              </div>
              <h2 className="text-2xl font-bold text-slate-900">{t.chapter3Title}</h2>
            </div>
            <p className="text-slate-600 leading-relaxed">
              {t.chapter3}
            </p>
          </div>

          {/* Chapter 4 */}
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-sky-100 flex items-center justify-center">
                <Sparkles className="w-5 h-5 text-sky-600" />
              </div>
              <h2 className="text-2xl font-bold text-slate-900">{t.chapter4Title}</h2>
            </div>
            <p className="text-slate-600 leading-relaxed">
              {t.chapter4}
            </p>
          </div>

          {/* Chapter 5 - Transformation */}
          <div className="mb-12 bg-green-50 rounded-2xl p-8">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                <Heart className="w-5 h-5 text-green-600" />
              </div>
              <h2 className="text-2xl font-bold text-green-800">{t.chapter5Title}</h2>
            </div>
            <p className="text-green-700 leading-relaxed">
              {t.chapter5}
            </p>
          </div>

          {/* Encouragement */}
          <div className="bg-gradient-to-r from-sky-600 to-blue-600 rounded-2xl p-8 text-center text-white mb-12">
            <p className="text-xl font-medium">
              "{t.encouragement}"
            </p>
            <p className="mt-4 text-sky-200">— Ioana Alexandra</p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="py-16 bg-slate-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <div className="text-center mb-8">
              <h2 className="text-2xl font-bold text-slate-900 mb-2">{t.contactMe}</h2>
              <p className="text-slate-600">{t.contactText}</p>
            </div>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <Button
                size="lg"
                className="bg-green-500 hover:bg-green-600 text-white rounded-full px-8"
                onClick={handleWhatsApp}
              >
                <MessageCircle className="w-5 h-5 mr-2" />
                {t.whatsapp}
              </Button>
              
              <Button
                size="lg"
                className="bg-sky-600 hover:bg-sky-700 text-white rounded-full px-8"
                onClick={() => window.open(LIFEWAVE_SHOP_URL, '_blank')}
              >
                <ExternalLink className="w-5 h-5 mr-2" />
                {t.shopNow}
              </Button>
            </div>
          </div>
        </div>
      </section>

      {/* Back to Products */}
      <section className="py-8">
        <div className="max-w-4xl mx-auto px-4 text-center space-y-8">
          {/* Share Buttons */}
          <ShareButtons 
            title={t.pageTitle}
            description={t.intro}
          />
          
          <Link 
            to="/products" 
            className="inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 font-medium"
          >
            {language === 'ro' ? 'Vezi Produsele' : language === 'de' ? 'Produkte ansehen' : 'View Products'}
            <ArrowRight className="w-5 h-5" />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default MyStoryPage;
